import { render, staticRenderFns } from "./StudentNew.vue?vue&type=template&id=e1201c8e&"
import script from "./StudentNew.vue?vue&type=script&lang=ts&"
export * from "./StudentNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports